import { Component, inject, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdresseDto } from '../../../core/models/adresse/adresse-dto.model';
import { LinkOpenerService } from '../../../core/services/link-opener.service';
import { DashboardCardComponent } from '../../dashboard/dashboardcard.component';

@Component({
  selector: 'bpw-ad-dashboardcard',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './ad-dashboardcard.component.html',
  styleUrls: ['./ad-dashboardcard.component.scss'],
})
export class AdDashboardcardComponent implements DashboardCardComponent {
  private readonly _linkOpenerService = inject(LinkOpenerService);

  @Input()
  public data: any;
  public visible: boolean;

  constructor() {
    this.visible = false;
  }

  openMapLink(ad: AdresseDto): void {
    this._linkOpenerService.mapLinkAdresse(ad);
  }
}
